var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"location-menu"},_vm._l((_vm.locations),function(location){return _c('li',{key:location.iso,staticClass:"location-menu__location"},[_c('location-select',{attrs:{"iso":location.iso,"name":location.name},on:{"click":function($event){return _vm.$emit('update', location.iso)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }